// @/services/content/store/modules/carbon-accounting-update.js
export class CarbonAccountingUpdateHandler {
  constructor(store) {
    this.store = store;
  }

  /**
   * Get Carbon Accounting Update content by locale
   * @param {string} locale Locale to get content for
   * @returns {Object|null} Content or null if not found
   */
  getContent(locale = 'en') {
    // Try requested locale first
    const localeContent = this.store.state.data.carbonAccountingUpdate?.[locale];
    if (localeContent) return localeContent;
    
    // Fall back to English if different locale was requested
    if (locale !== 'en') {
      return this.store.state.data.carbonAccountingUpdate?.['en'] || null;
    }
    
    return null;
  }
}